import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type CartitemDetailsProps = {
  children: ReactNode;
  className?: string;
};

const CartItemDetails = ({ children, className }: CartitemDetailsProps) => {
  return (
    <div
      className={cn(
        "col-span-1 col-start-2 grid grid-cols-[1fr_auto] grid-rows-[auto_1fr] gap-x-1 gap-y-2 overflow-hidden px-4 py-3",
        className,
      )}
    >
      {children}
    </div>
  );
};

CartItemDetails.displayName = "CartItemDetails";

export default CartItemDetails;
